export default "__VITE_ASSET__BP2k4pWs__"